import React, { useEffect, useState } from "react";

import CountUp from "react-countup";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import Slider from "react-slick";
import AOS from "aos";
import "aos/dist/aos.css";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { Tour, AdminService } from "../../genezio-sdk/westtigermotors";
import { Faq } from "../../components/Faq";
import { Testimonials } from "../../components/Testimonials";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./calendar.css";
import dayjs from "dayjs";
import { OurTours } from "../pages/OurTours";
import { useTranslation } from "react-i18next";
import { Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { articleStructuredData } from "../../components/Auth/utils";
// import { BrowserView, MobileView } from "react-device-detect";

const Home = () => {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, []);
  const { t } = useTranslation();

  // const [soldOutDates, setSoldOutDates] = useState<Date[]>([]);

  const [availableDates, setAvailableDates] = useState<Date[]>([]);

  const [date, setDate] = useState<Date | null>(null);

  // const locations = [
  //   { value: "Bucharest", label: t("home.search.locations.bucharest") }
  //   // { value: "Brasov", label: t("home.search.locations.brasov") },
  //   // { value: "Training", label: t("home.search.locations.training") }
  // ];
  // const [hovered, setHovered] = useState(false);

  // useEffect(() => {
  //   async function getAvailableDates() {
  //     if (!startLocation) {
  //       // get all available dates from tours
  //       const dates = tours
  //         .map((tour) => tour.tourDates)
  //         .flat()
  //         .map((date) => new Date(date));
  //       setAvailableDates(dates);
  //       return;
  //     }

  //     const resp = await SiteService.getAvailableDatesByStartLocation(
  //       startLocation || "",
  //       selectedTourId
  //     ).catch((err) => {
  //       console.error(err);
  //       return null;
  //     });
  //     if (!resp) {
  //       return;
  //     }
  //     if (startLocation === "Training") {
  //       setSelectedTourId(process.env.REACT_APP_TRAINING_ID);
  //     }
  //     setAvailableDates(resp.availableDates.map((date) => new Date(date)));
  //     setAvailableDatesDays(resp.days);
  //     // setAvailableDatesColors(resp.colors);
  //     // setSoldOutDates(resp.soldOutDates.map((date) => new Date(date)));
  //   }

  //   getAvailableDates();
  // }, [startLocation, selectedTourId]);

  useEffect(() => {
    async function getTours() {
      const tours = await AdminService.getTours().catch((err) => {
        console.error(err);
        return [];
      });
      const availableDates = tours.flatMap((tour: Tour) =>
        (tour.tourDates || []).map((date) => new Date(date))
      );

      // remove duplicate dates
      const uniqueDates = Array.from(
        new Set(availableDates.map((date) => date.toDateString()))
      )
        .map((dateString) => new Date(dateString))
        .filter((date) => date >= new Date(new Date().setHours(0, 0, 0, 0)));

      setAvailableDates(uniqueDates);
    }

    getTours();
  }, []);

  async function search() {
    if (!date) {
      alert(t("home.search.searchNoDateAlert"));
      return;
    }

    // const tour = await SiteService.getTourByDateAndStartLocation(
    //   startLocation || "",
    //   date.getTime()
    // ).catch((err) => {
    //   console.error(err);
    //   return null;
    // });

    // if (!tour) {
    //   alert(t("home.search.alertNoTours"));
    //   return;
    // }

    // if (tour.startLocation === "Training") {
    //   window.location.href = `/training/${tour.id}/${date.getTime()}`;
    //   return;
    // }

    window.location.href = `/tururile-noastre?date=${date.getTime()}`;
  }

  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  // const rentalslideroption = {
  //   dots: false,
  //   nav: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   centerMode: false,

  //   // allow exactly 3 slides to show on screen
  //   slidesToScroll: 1,
  //   responsive: [
  //     {
  //       breakpoint: 2000,
  //       settings: {
  //         slidesToShow: 1,
  //         autoplay: true,
  //         autoplaySpeed: 4000
  //       }
  //     },
  //     {
  //       breakpoint: 1000,
  //       settings: {
  //         slidesToShow: 1,
  //         autoplay: true,
  //         autoplaySpeed: 4000
  //       }
  //     },
  //     {
  //       breakpoint: 700,
  //       settings: {
  //         slidesToShow: 1,
  //         autoplay: true,
  //         autoplaySpeed: 4000
  //       }
  //     },
  //     {
  //       breakpoint: 550,
  //       settings: {
  //         slidesToShow: 1,
  //         autoplay: true,
  //         autoplaySpeed: 4000
  //       }
  //     },
  //     {
  //       breakpoint: 0,
  //       settings: {
  //         slidesToShow: 1,
  //         autoplay: true,
  //         autoplaySpeed: 4000
  //       }
  //     }
  //   ]
  // };
  return (
    <>
      {localStorage.getItem("i18nextLng") === "ro" ? (
        <Helmet>
          <link rel="canonical" href="https://firstgearclub.com" />

          <link
            rel="alternate"
            hrefLang="ro"
            href="https://firstgearclub.com"
          />
          <link
            rel="alternate"
            hrefLang="en"
            href="https://firstgearclub.com?lang=en"
          />
          <title>
            Experienta off-road Romania - Trasee 4x4 cu ghid - First Gear Club
          </title>
          <meta
            name="description"
            content="Descopera experienta off road impreuna cu ghizii nostriexperimentati. Trasee montane, masini 4x4 performante ⭐ Aventura garantata."
          />
        </Helmet>
      ) : (
        <Helmet>
          <link rel="canonical" href="https://firstgearclub.com" />

          <link
            rel="alternate"
            hrefLang="ro"
            href="https://firstgearclub.com"
          />
          <link
            rel="alternate"
            hrefLang="en"
            href="https://firstgearclub.com?lang=en"
          />
          <title>
            Off-Road adventure tours - Romanian 4x4 experience - First Gear Club
          </title>
          <meta
            name="description"
            content="Discover the off road experience together with our experienced guides. Mountain trails, high-performance 4x4 cars ⭐ Adventure guaranteed."
          />
        </Helmet>
      )}

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(articleStructuredData)
        }}
      />
      {/* Banner */}
      <section className="banner-section banner-slider">
        <div className="container">
          <div className="home-banner">
            <div className="row align-items-center">
              <div className="col-lg-8">
                <h1 className="primaryFont" style={{ color: "white" }}>
                  <span>{t("home.hero.titleRow1")}</span> <br />
                  {t("home.hero.titleRow2")}
                </h1>
                <p>{t("home.hero.text")}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="video-container">
        <iframe
          src="https://www.youtube.com/embed/-EtEp3Oj_gE?autoplay=1&mute=1&loop=1&controls=0&playlist=-EtEp3Oj_gE"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; loop"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
        <div className="dark-overlay"></div>
        <div className="overlay-text w-100">
          <h1 className="primaryFont" style={{ color: "white" }}>
            {t("home.hero.titleRow2")}
          </h1>
        </div>
      </section> */}
      {/* /Banner */}
      {/* Search */}

      {/* <section className="section popular-services pt-4 pb-1">
        <div className="container">
           <div className="section-heading" data-aos="fade-down">
            <h2 className="primaryFont">{t("home.promoAds.title")}</h2>
          </div> 
          <div className="row">
            <div className="popular-slider-group">
              <div className=" rental-deal-slider ">
                <Slider {...rentalslideroption} className="rental-slider">
                  <div className="rental-car-item">
                    <div className="listing-item mb-0">
                      <div className="listing-img">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            window.location.href = `/tur/dobrogea-trail-672959c54e0adf3249050302/`;
                          }}
                        >
                          <BrowserView>
                            <img
                              src={`assets/img/banners/banner_dobrogea_web_${i18n.language === "ro" ? "ro" : "eng"}.webp`}
                              className="img-fluid"
                              alt="banner-dobrogea"
                              loading="lazy"
                            />
                          </BrowserView>
                          <MobileView>
                            <img
                              src={`assets/img/banners/banner_dobrogea_tel_${i18n.language === "ro" ? "ro" : "eng"}.webp`}
                              className="img-fluid"
                              alt="banner-dobrogea"
                              loading="lazy"
                            />
                          </MobileView>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="rental-car-item">
                    <div className="listing-item mb-0">
                      <div className="listing-img">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            window.location.href = `/?popup=signup`;
                          }}
                        >
                          <BrowserView>
                            <img
                              src={`assets/img/banners/banner_membru_web_${i18n.language === "ro" ? "ro" : "eng"}.webp`}
                              className="img-fluid"
                              alt="banner-membru"
                              loading="lazy"
                            />
                          </BrowserView>
                          <MobileView>
                            <img
                              src={`assets/img/banners/banner_membru_tel_${i18n.language === "ro" ? "ro" : "eng"}.webp`}
                              className="img-fluid"
                              alt="banner-membru"
                              loading="lazy"
                            />
                          </MobileView>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="rental-car-item">
                    <div className="listing-item mb-0">
                      <div className="listing-img">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            window.location.href = `/partener-de-calatorie`;
                          }}
                        >
                          <BrowserView>
                            <img
                              src={`assets/img/banners/banner_partener_web_${i18n.language === "ro" ? "ro" : "eng"}.webp`}
                              className="img-fluid"
                              alt="banner-partener"
                              loading="lazy"
                            />
                          </BrowserView>
                          <MobileView>
                            <img
                              src={`assets/img/banners/banner_partener_tel_${i18n.language === "ro" ? "ro" : "eng"}.webp`}
                              className="img-fluid"
                              alt="banner-partener"
                              loading="lazy"
                            />
                          </MobileView>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="rental-car-item">
                    <div className="listing-item mb-0">
                      <div className="listing-img">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            window.location.href = `/experienta-off-road-voucher-cadou `;
                          }}
                        >
                          <BrowserView>
                            <img
                              src={`assets/img/banners/banner_voucher_web_${i18n.language === "ro" ? "ro" : "eng"}.webp`}
                              className="img-fluid"
                              alt="banner-voucher"
                              loading="lazy"
                            />
                          </BrowserView>
                          <MobileView>
                            <img
                              src={`assets/img/banners/banner_voucher_tel_${i18n.language === "ro" ? "ro" : "eng"}.webp`}
                              className="img-fluid"
                              alt="banner-voucher"
                              loading="lazy"
                            />
                          </MobileView>
                        </a>
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <div className="section-search" id="search-section">
        <div className="container">
          <div className="search-box-banner">
            <Row className="align-items-start justify-content-evenly">
              <div className="mt-2 col-12 col-md-5">
                <div className="input-block p-0">
                  <label className="label-custom-search-home">
                    {t("home.search.selectDateActivities")}
                  </label>
                </div>
                <div className="input-block-wrapp">
                  <div className="input-block date-widget w-100 p-0">
                    <div className="group-img w-100">
                      <div
                        className="calendar-container w-100"
                        // onMouseEnter={() => setHovered(true)}
                        // onMouseLeave={() => setHovered(false)}
                      >
                        {/* {hovered && (
                          <div className="calendar-popup">
                            <button
                              type="button"
                              className="btn-close float-end"
                              aria-label="Close"
                              onClick={() => setHovered(false)}
                            ></button> */}
                        <div className="call-us-popup">
                          <p className="call-us-popup__text">
                            {t("home.search.callUsForAvailability")}

                            <a
                              href="tel:+40744788888"
                              className="call-us-popup__phone ms-2"
                            >
                              +40 7447 88888
                            </a>
                          </p>
                        </div>
                        {availableDates && availableDates.length > 0 && (
                          <Calendar
                            value={date}
                            defaultActiveStartDate={
                              availableDates && availableDates.length > 0
                                ? // sort available dates by newest first
                                  availableDates.sort(
                                    (a, b) =>
                                      dayjs(a).valueOf() - dayjs(b).valueOf()
                                  )[0]
                                : new Date()
                            }
                            onChange={(e) => {
                              const localDate = e as Date;
                              if (!localDate) {
                                setDate(null);
                                return;
                              }

                              const foundDate = availableDates.find(
                                (d) =>
                                  dayjs(d).format("YYYY-MM-DD") ===
                                  dayjs(localDate).format("YYYY-MM-DD")
                              );

                              if (foundDate) {
                                setDate(
                                  new Date(
                                    Date.UTC(
                                      foundDate.getFullYear(),
                                      foundDate.getMonth(),
                                      foundDate.getDate()
                                    )
                                  )
                                );
                                return;
                              }
                            }}
                            className="w-100"
                            tileClassName={(elems) => {
                              const localDate = elems.date as Date;
                              const view = elems.view;
                              if (view !== "month") {
                                return "";
                              }

                              const indexOfSelected = availableDates.findIndex(
                                (d) =>
                                  dayjs(d).format("YYYY-MM-DD") ===
                                  dayjs(date).format("YYYY-MM-DD")
                              );
                              if (
                                indexOfSelected >= 0 &&
                                dayjs(availableDates[indexOfSelected]).format(
                                  "YYYY-MM-DD"
                                ) === dayjs(localDate).format("YYYY-MM-DD")
                              ) {
                                return "active-date";
                              }

                              const indexAvailable = availableDates
                                .map((d) => dayjs(d).format("YYYY-MM-DD"))
                                .indexOf(dayjs(localDate).format("YYYY-MM-DD"));

                              if (indexAvailable >= 0) {
                                return `highlight-date`;
                              }

                              return "disabled-date";
                            }}
                            showNeighboringMonth={false}
                          />
                        )}
                        {/* </div> 
                        )}
                        <div className="hover-target w-100">
                          {date?.toDateString() ||
                            t("home.search.openCalendar")}
                        </div>*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="column-group-last p-1">
                <div className="input-block">
                  <div className="search-btn mt-0">
                    <button
                      className="btn search-button"
                      onClick={(e) => {
                        e.preventDefault();
                        if (!date) {
                          alert(t("home.search.searchNoDateAlert"));
                        }
                        search();
                      }}
                    >
                      <i className="fa fa-search" aria-hidden="true" />
                      {t("home.search.searchLabel")}
                    </button>
                  </div>
                </div>
              </div>
            </Row>
          </div>
        </div>
      </div>
      {/* /Search */}

      <div className="mt-4 w-100"></div>

      <OurTours isHomePage />

      {/* services */}
      {/* <section className="section services" style={{ background: "#F2F7F6" }}>
        <div className="service-right">
          <ImageWithBasePath
            src="assets/img/bg/service-right.svg"
            className="img-fluid"
            alt="services right"
          />
        </div>
        <div className="container">
          <div className="section-heading">
            <h2 className="primaryFont">{t("home.howItWorksSection.title")}</h2>
          </div>
          <div className="services-work">
            <div className="row">
              <div className="col-lg-4 col-md-4 col-12 d-flex">
                <div className="services-group service-date flex-fill">
                  <div className="mb-4">
                    <img
                      src="assets/img/photo1.jpg"
                      alt=""
                      height={180}
                      className="img-fluid rounded-4"
                      loading="lazy"
                    />
                  </div>
                  <div className="services-content">
                    <h3>{t("home.howItWorksSection.step1.title")}</h3>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("home.howItWorksSection.step1.text")
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-12  d-flex">
                <div className="services-group service-loc flex-fill">
                  <div className="mb-4">
                    <img
                      src="assets/img/photo2.jpg"
                      alt=""
                      height={180}
                      className="img-fluid rounded-4"
                      loading="lazy"
                    />
                  </div>
                  <div className="services-content">
                    <h3>{t("home.howItWorksSection.step2.title")}</h3>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("home.howItWorksSection.step2.text")
                      }}
                    />
                    <br />
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-12 d-flex">
                <div className="services-group service-book flex-fill">
                  <div className="mb-4">
                    <img
                      src="assets/img/photo3.jpg"
                      alt=""
                      height={180}
                      className="img-fluid rounded-4"
                      loading="lazy"
                    />
                  </div>
                  <div className="services-content">
                    <h3>{t("home.howItWorksSection.step3.title")}</h3>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("home.howItWorksSection.step3.text")
                      }}
                    />
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* /services */}

      {/* Facts By The Numbers */}
      <section className="section facts-number">
        <div className="container">
          {/* Heading title*/}
          <div className="section-heading">
            <h2 className="title text-white primaryFont">
              {t("home.factsSection.title")}
            </h2>
            {/* <p className="description text-white">
              {t("home.factsSection.subtitle")}
            </p> */}
          </div>
          {/* /Heading title */}
          <div className="counter-group">
            <div className="row">
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-heart.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={1000}
                          duration={3}
                          separator=","
                        />
                        +<br />
                      </h4>
                      <p>{t("home.factsSection.fact1.text")}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-car.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={5}
                          duration={2}
                          separator=","
                        />
                        +<br />
                      </h4>
                      <p>{t("home.factsSection.fact2.text")}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-headphone.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={625}
                          duration={3}
                          separator=","
                        />
                        K+
                        <br />
                      </h4>
                      <p>{t("home.factsSection.fact3.text")}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-history.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={200}
                          duration={3}
                          separator=","
                        />
                        K+
                        <br />
                      </h4>
                      <p>{t("home.factsSection.fact4.text")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /Facts By The Numbers */}

      {/* Why Choose Us */}
      <section className="section why-choose popular-explore">
        <div className="choose-left">
          <ImageWithBasePath
            src="assets/img/bg/choose-left.png"
            className="img-fluid"
            alt="Why Choose Us"
          />
        </div>
        <div className="container">
          {/* Heading title*/}
          <div className="section-heading">
            <h2 className="primaryFont">{t("home.whyUsSection.title")}</h2>
            {/* <p>{t("home.whyUsSection.subtitle")}</p> */}
          </div>
          {/* /Heading title */}
          <div className="why-choose-group">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-12 d-flex">
                <div className="card flex-fill">
                  <div className="card-body">
                    <div className="choose-img choose-black">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-selection.svg"
                        alt=""
                      />
                    </div>
                    <div className="choose-content">
                      <h4>{t("home.whyUsSection.reason1.title")}</h4>
                      <p>{t("home.whyUsSection.reason1.text")}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 d-flex">
                <div className="card flex-fill">
                  <div className="card-body">
                    <div className="choose-img choose-secondary">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-crown.svg"
                        alt=""
                      />
                    </div>
                    <div className="choose-content">
                      <h4>{t("home.whyUsSection.reason2.title")}</h4>
                      <p>{t("home.whyUsSection.reason2.text")}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 d-flex">
                <div className="card flex-fill">
                  <div className="card-body">
                    <div className="choose-img choose-primary">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-user-check.svg"
                        alt=""
                      />
                    </div>
                    <div className="choose-content">
                      <h4>{t("home.whyUsSection.reason3.title")}</h4>
                      <p>{t("home.whyUsSection.reason3.text")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /Why Choose Us */}
      {/* About us Testimonials */}
      <Testimonials />
      {/* About us Testimonials */}
      {/* FAQ  */}
      <Faq isHomePage={true} />
      {/* /FAQ */}
    </>
  );
};

export default Home;
